<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("account request settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('onfido profile')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/onfido/profile/catalog"
            name_field="name"
            value_field="profile_id"
            @selected="onfido_profile_changed"
            ref="onfido_profile_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('shortlink profile')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/shortlink/profile/catalog"
            name_field="name"
            value_field="profile_id"
            @selected="shortlink_profile_changed"
            ref="shortlink_profile_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('renap profile')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/renap/profile/catalog"
            name_field="name"
            value_field="profile_id"
            @selected="renap_profile_changed"
            ref="renap_profile_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="box">
      <div class="title is-4">{{ $t("truvalidate") }}</div>
      <div class="field">
        <label class="label">{{ $t("api url") }}:</label>
        <div class="control">
          <input class="input" v-model="meta.truvalidate_api_url" />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("environment") }}:</label>
            <div class="select is-fullwidth">
              <select v-model="meta.truvalidate_environment">
                <option value="sandbox">{{ $t("sandbox") }}</option>
                <option value="production">{{ $t("production") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("user") }}:</label>
            <div class="control">
              <input class="input" v-model="meta.truvalidate_user" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("password") }}:</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.truvalidate_password"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Botón de guardar -->
    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "AccountRequestSettings",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      meta: {
        auto_approval_enabled: false,
        expiration_days: 7,
        default_notes: "",
        email_notifications_enabled: true,
      }, // Configuraciones del módulo
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("settings saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    drive_changed(selected) {
      let v = this;
      if (selected) v.meta.drive_id = selected.drive_id;
    },
    renap_profile_changed(selected) {
      let v = this;
      if (selected) v.meta.renap_profile_id = selected.profile_id;
    },
    shortlink_profile_changed(selected) {
      let v = this;
      if (selected) v.meta.shortlink_profile_id = selected.profile_id;
    },
    onfido_profile_changed(selected) {
      let v = this;
      if (selected) v.meta.onfido_profile_id = selected.profile_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) v.meta = conf;

        if (conf && conf.drive_id)
          v.$refs.drive_dropdown.set_value(conf.drive_id);
        if (conf && conf.renap_profile_id)
          v.$refs.renap_profile_dropdown.set_value(conf.renap_profile_id);
        if (conf && conf.shortlink_profile_id)
          v.$refs.shortlink_profile_dropdown.set_value(
            conf.shortlink_profile_id
          );
        if (conf && conf.onfido_profile_id)
          v.$refs.onfido_profile_dropdown.set_value(conf.onfido_profile_id);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>
